export default {"src":"https://cdn.tanzhi.cn/_next/static/media/hierarchy.784938b2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};